import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "detail-grid" }
const _hoisted_3 = { class: "detail-icon icon-bg" }
const _hoisted_4 = { class: "detail-label" }
const _hoisted_5 = { class: "detail-value" }

type DetailItem = {
  icon: string;
  label: string;
  value: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetailDetailsSection',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-header" }, [
      _createElementVNode("p", { class: "section-title" }, "Customer Detail")
    ], -1)),
    _createVNode(_component_v_divider),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.label,
          class: "detail-item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, { size: "16" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.icon), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(item.label), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.value), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})